var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { AfterViewInit, ElementRef } from '@angular/core';
import { NavigationService } from '../../services/navigation/navigation.service';
import { PageNames } from '../page-names.enum';
import { SelectableNavigationItem } from '../../model/selectable-navigation-item';
import { TvShopStateService } from '../../services/state/tv-shop-state.service';
var ArrowComponent = /** @class */ (function (_super) {
    __extends(ArrowComponent, _super);
    function ArrowComponent(navigationService, stateService) {
        var _this = _super.call(this) || this;
        _this.navigationService = navigationService;
        _this.stateService = stateService;
        _this.pointsDown = true;
        _this.showArrow = true;
        return _this;
    }
    ArrowComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.navigationService.registerNavigation(this, PageNames.ARROW_DIRECTION);
        this.stateService.isTrailerPlaying$.subscribe(function (trailerPlaying) {
            _this.showArrow = !trailerPlaying;
        });
    };
    ArrowComponent.prototype.onEnter = function () {
        this.onBack();
    };
    ArrowComponent.prototype.onBack = function () {
        this.navigationService.resetPage();
    };
    return ArrowComponent;
}(SelectableNavigationItem));
export { ArrowComponent };
